import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    Renderer2,
    SimpleChanges,
} from "@angular/core";
import Funcionalidades from "@shared/enums/funcionalidades.enum";
import { SessionService } from "@services/session.service";
import ISidebar from "@models/sidebar.interface";

@Component({
    selector: "app-sidebar",
    templateUrl: "./sidebar.component.html",
    styleUrls: ["./sidebar.component.scss"],
})
export class SidebarComponent {
    @Input() isSidebarOpen = true;
    @Output() toggle = new EventEmitter<void>();

    private _sidebar: ISidebar[] = []; // Variable que almacena las funcionalidades que se mostrarán en el sidebar al usuario que inicio sesión

    private documentClickListener?: () => void;

    constructor(
        private elementRef: ElementRef,
        private renderer: Renderer2,
        private sessionService: SessionService,
    ) { }

	ngOnInit() {
		this.sessionService.permisosSeleccionados$.subscribe((permisos) => {
			// Cuando cambien los permisos, vuelve a evaluar el sidebar
			if (permisos) this._sidebar = this.sidebar().filter((i) => i.visible);
		});
	}

    /* Filtra y asigna los items que se deben mostrar al momento que el usuario inicia sesión */
    get sidebarItems(): ISidebar[] {
        return this.sessionService.rolActual ? this._sidebar : [];
    }

    /* Se agregan todas las funcionalidades que se mostraran en el sidebar */
    sidebar(): ISidebar[] {
        return [
            {
                ruta: "/expedientes/crear",
                alt: this.sessionService.getFunctionality(Funcionalidades.crear_expediente)?.ayuda_fnc,
                icono: "bi-file-earmark-plus",
                label: this.sessionService.getFunctionality(Funcionalidades.crear_expediente)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.crear_expediente)
            },
            {
                ruta: "/expedientes/creados",
                alt: this.sessionService.getFunctionality(Funcionalidades.revisar_expediente)?.ayuda_fnc,
                icono: "bi-file-earmark-diff",
                label: this.sessionService.getFunctionality(Funcionalidades.revisar_expediente)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.revisar_expediente)
            },
            {
                ruta: "/solicitudes-antecedentes",
                alt: this.sessionService.getFunctionality(Funcionalidades.revisar_solicitudes)?.ayuda_fnc,
                icono: "bi-file-earmark-zip",
                label: this.sessionService.getFunctionality(Funcionalidades.revisar_solicitudes)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.revisar_solicitudes)
            },
            {
                ruta: "/plantillas-documentos",
                alt: this.sessionService.getFunctionality(Funcionalidades.ver_plantillas)?.ayuda_fnc,
                icono: "bi-file-earmark-text",
                label: this.sessionService.getFunctionality(Funcionalidades.ver_plantillas)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.ver_plantillas)
            },
            {
                ruta: "/expedientes/prorrogas",
                alt: this.sessionService.getFunctionality(Funcionalidades.revisar_prorrogas)?.ayuda_fnc,
                icono: "bi-file-earmark-ppt",
                label: this.sessionService.getFunctionality(Funcionalidades.revisar_prorrogas)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.revisar_prorrogas)
            },
            {
                ruta: "/expedientes/aprobados",
                alt: this.sessionService.getFunctionality(Funcionalidades.revisar_expedientes_aprobados)?.ayuda_fnc,
                icono: "bi-file-earmark-check",
                label: this.sessionService.getFunctionality(Funcionalidades.revisar_expedientes_aprobados)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.revisar_expedientes_aprobados)
            },
            {
                ruta: "/expedientes/historial",
                alt: this.sessionService.getFunctionality(Funcionalidades.revisar_expedientes_historial)?.ayuda_fnc,
                icono: "bi-file-earmark-text",
                label: this.sessionService.getFunctionality(Funcionalidades.revisar_expedientes_historial)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.revisar_expedientes_historial)
            },
            {
                ruta: "/expedientes/resoluciones",
                alt: this.sessionService.getFunctionality(Funcionalidades.revisar_resoluciones_a_firmar)?.ayuda_fnc,
                icono: "bi-file-earmark-ruled",
                label: this.sessionService.getFunctionality(Funcionalidades.revisar_resoluciones_a_firmar)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.revisar_resoluciones_a_firmar)
            },
            {
                ruta: "/expedientes/antecedentes",
                alt: this.sessionService.getFunctionality(Funcionalidades.revisar_antecedentes)?.ayuda_fnc,
                icono: "bi-file-earmark-ruled",
                label: this.sessionService.getFunctionality(Funcionalidades.revisar_antecedentes)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.revisar_antecedentes)
            },
            {
                ruta: "/expedientes/apelaciones",
                alt: this.sessionService.getFunctionality(Funcionalidades.revisar_apelaciones)?.ayuda_fnc,
                icono: "bi-file-earmark-break",
                label: this.sessionService.getFunctionality(Funcionalidades.revisar_apelaciones)?.nombre_fnc,
                visible: this.sessionService.hasFunctionality(Funcionalidades.revisar_apelaciones)
            }
        ]
    }

    closeSidebar(event?: Event): void {
        if (this.isSidebarOpen || event) this.toggle.emit();
    }
}